module.exports = __webpack_public_path__ + "img/dropdown.2c98f458.svg";